import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
} from "@mui/material";
import {
  AccountCircle,
  FileUploadOutlined,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { ReactComponent as Logo } from "../svg/logoVertical.svg";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../store/auth/hooks";
import { useUploadQueue } from "../store/uploadQueue/hooks";
import { useSnackbars } from "../store/snackbars/hooks";
import "../App.css";
import { UploadingSnackbar } from "./snackbars";
import { useDrawer } from "../store/drawer/hooks";

export default function PrimaryAppBar() {
  const { toggleDrawer } = useDrawer();

  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const { logout: authLogout } = useAuth();
  const { isUploading } = useUploadQueue();
  const {
    closeUploadingSnackbar,
    openUploadingSnackbar,
    toggleUploadingSnackbar,
  } = useSnackbars();

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await authLogout();
    navigate("/");
  };

  const menuId = "primary-search-account-menu";

  useEffect(() => {
    if (isUploading) {
      openUploadingSnackbar();
    } else {
      closeUploadingSnackbar();
    }

    const handleBeforeUnload = (event) => {
      if (isUploading) {
        event.preventDefault();
        event.returnValue = ""; // Required for some browsers to display the warning
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isUploading]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <AppBar
        elevation={0}
        color="primary"
        position="relative"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar disableGutters sx={{ height: 64, px: 2 }}>
          <IconButton
            onClick={() => toggleDrawer()}
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Logo className="appBarLogo" />
          <Box ml="auto">
            {isUploading && (
              <Tooltip title="Toggle Import Status">
                <IconButton
                  size="large"
                  aria-label="toggle import snackbar"
                  onClick={() => toggleUploadingSnackbar()}
                  color="inherit"
                >
                  <FileUploadOutlined className="pulseIcon" />
                </IconButton>
              </Tooltip>
            )}
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        aria-hidden={!isMenuOpen}
        id={menuId}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      <UploadingSnackbar />
    </>
  );
}
